export default __webpack_public_path__ + "static/media/MAP.47193134.png";